// Purchased Products Manager - Handles fetching user's purchased products
// Follows the Manager pattern from ProductsManager

import { Manager } from '../../../../../core';
import { logger } from '../../../../../core';

export class PurchasedProductsManager extends Manager {
  constructor() {
    super();
    this.isLoading = false;
  }

  async initGlobalVariables() {}

  async initStates() {
    logger.log(
      { tags: 'manager|purchased-products|init', color1: 'cyan' },
      'Initializing PurchasedProductsSection manager states'
    );
    logger.log(
      { tags: 'manager|purchased-products|ready', color1: 'lime' },
      'PurchasedProductsSection manager initialized'
    );
  }

  /**
   * Get purchased products from backend API (auth required)
   * @param {number} page - Page number
   * @param {number} limit - Items per page
   * @param {string} query - Optional search query to filter within purchased products
   */
  async getPurchasedProductsFromAPI(page = 1, limit = 25, query = '') {
    try {
      const params = new URLSearchParams({
        page: String(page),
        limit: String(limit),
      });
      if (query && query.trim()) {
        params.set('q', query.trim());
      }

      const response = await fetch(`/api/products/purchased?${params.toString()}`, {
        credentials: 'include',
      });

      if (response.status === 401) {
        return { products: [], total: 0, page, limit, unauthorized: true };
      }

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      if (!data.success) {
        return { products: [], total: 0, page, limit };
      }

      return {
        products: data.products || [],
        total: data.total || 0,
        page: data.page || page,
        limit: data.limit || limit,
      };
    } catch (error) {
      logger.error('purchased-products', 'Failed to fetch purchased products:', error);
      return { products: [], total: 0, page, limit };
    }
  }
}
